import clsx from 'clsx';
import React, { useState } from 'react';
import parse from 'react-html-parser';

import styles from './FooterStyles.module.css';

const EMAIL_CONTENT = `
<p>Hi, I subscribe to The Information and find it to be a really valuable resource.</p>
<p>It helps me stay up to date with key industry trends that impact our business, and I consistently follow breaking news about us and our competitors.</p>
<p>The Information has a great corporate group program. Can you evaluate this for us as a team? It seems like it might be great for us.</p>
`;

const FooterSection = ({ companyName }: { companyName?: string }) => {
  const [copyText, setCopyText] = useState('Copy');

  const ClickHandler = () => {
    navigator.clipboard.writeText(
      parse(EMAIL_CONTENT.replaceAll('<p>', '').replaceAll('</p>', ''))
    );
    setCopyText('Copied!');
    setTimeout(() => setCopyText('Copy'), 2000);
    // @ts-expect-error TODO: import ahoy instead of using global instance?
    trackEvent('Clicks', 'Copied Company Invite', {});
  };

  return (
    <div className={styles.referralFooterContainer}>
      <div className="container">
        <div className={clsx(styles.referralCorporate, 'row')}>
          <div className="col-sm-12 col-md-6">
            <div className={styles.corperateheader}>Corporate Subscription</div>
            <div className={styles.corporateSubheader}>
              Share The Information with{' '}
              {companyName && companyName !== 'The Information' ? `${companyName}` : 'your company'}
            </div>
            <div className={styles.corporateDescription}>
              Expensing The Information? Rather have the company pay your bill for a group plan so
              everyone benefits? We offer great corporate account perks and would be happy to help
              set up your account. Get the conversation started with your team.
            </div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div className={styles.sampleEmailContainer}>
              <div className={styles.sampleEmailSubject}>
                Subject: The Information Corporate Subscription
              </div>
              <div className={styles.sampleEmailContent}>{parse(EMAIL_CONTENT)}</div>
              <div className={styles.copySampleTextBtn} onClick={ClickHandler}>
                {copyText}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
